import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79bf621a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79bf621a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf621a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bf621a')) {
      api.createRecord('79bf621a', component.options)
    } else {
      api.reload('79bf621a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79bf621a&scoped=true", function () {
      api.rerender('79bf621a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/icons/index.vue"
export default component.exports